export function initDropdown() {
	$("[data-dropdown]").click(function (e) {
		const el = $(this);
		const attr = el.attr("data-dropdown") === "expanded" ? "" : "expanded";
		el.attr("data-dropdown", attr);
	});
}
